/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ILabTestItem } from 'app/shared/model/lab-test-item.model';
import { IBloodBank } from 'app/shared/model/blood-bank.model';

export interface IBloodBankInvestigationList {
  id?: string;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  test?: ILabTestItem | null;
  bank?: IBloodBank | null;
}

export const defaultValue: Readonly<IBloodBankInvestigationList> = {
  active: false,
};
